import {compileNativeTemplate,type CompiledTemplate} from './compileNativeTemplate';

export type NativeCompilationCache=Map<string,Promise<CompiledTemplate>>;
/** One command only. Content identity and defensive copies keep capture evidence immutable. */
export async function compileCachedNativeTemplate(html:string,module:string,page:string,prefix:string,cache?:NativeCompilationCache,selector?:string):Promise<CompiledTemplate>{
 if(!cache)return compileNativeTemplate(html,module,page,prefix,selector);
 const digest=Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(String(html)))));
 const key=JSON.stringify([module,page,prefix,selector,digest]);
 if(!cache.has(key)){
  if(cache.size>=64)return compileNativeTemplate(html,module,page,prefix,selector);
  cache.set(key,compileNativeTemplate(html,module,page,prefix,selector));
 }
 return structuredClone(await cache.get(key)!);
}
